/* eslint-disable implicit-arrow-linebreak */
import React, { useState, useContext, createContext } from 'react';

export type QLEType = {
  eventType: string;
  files?: FileList | null | string[];
  lifeEvent: string;
  description: string;
  eventDate: string | Date;
  isEventInEligiblePeriod?: boolean;
};

interface IStoreContext {
  benefitType: string | null;
  benefitTypeModal: boolean;
  smoker: boolean;
  qle?: QLEType;
  // eslint-disable-next-line no-unused-vars
  setSelectedBenefitType: (b: string) => void;
  // eslint-disable-next-line no-unused-vars
  setBenefitTypeEditModal: (b: boolean) => void;
  // eslint-disable-next-line no-unused-vars
  setSmoker: (b: boolean) => void;
  clearSelectedBenefitType: () => void;
  // eslint-disable-next-line no-unused-vars
  setQleData: (b: QLEType) => void;
  clearQleData: () => void;
}

const useStore = (): IStoreContext => {
  const [benefitType, setBenefitType] = useState<string | null>(null);
  const [benefitTypeModal, setBenefitTypeModal] = useState<boolean>(false);
  const [smoker, setSmoker] = useState<boolean>(false);
  const [qle, setQle] = useState<QLEType>();

  const setSelectedBenefitType = (b: string): void => {
    setBenefitType(b);
  };

  const clearSelectedBenefitType = (): void => {
    setBenefitType(null);
  };

  const setBenefitTypeEditModal = (value: boolean): void => {
    setBenefitTypeModal(value);
  };

  const setQleData = (value: QLEType): void => {
    setQle(value);
  };

  const clearQleData = (): void => {
    setQle(undefined);
  };

  return {
    benefitType,
    benefitTypeModal,
    smoker,
    setSmoker,
    setSelectedBenefitType,
    clearSelectedBenefitType,
    setBenefitTypeEditModal,
    qle,
    setQleData,
    clearQleData,
  };
};

const StoreContext = createContext<IStoreContext | null>(null);

export const StoreContextProvider: React.FC = ({ children }) => (
  <StoreContext.Provider value={useStore()}>{children}</StoreContext.Provider>
);

export const useBenefitType = (): string | null => useContext(StoreContext)?.benefitType ?? null;

export const useBenefitEnrollSelectionModalIsOpen = (): boolean => useContext(StoreContext)?.benefitTypeModal ?? false;

export const useClearBenefitType = (): (() => void) => useContext(StoreContext)?.clearSelectedBenefitType ?? (() => {});

// eslint-disable-next-line no-unused-vars
export const useSetBenefitType = (): ((b: string) => void) =>
  useContext(StoreContext)?.setSelectedBenefitType ?? (() => {});

export const useSetBenefitEnrollSelectionModal = (): ((
  // eslint-disable-next-line no-unused-vars
  value: boolean
) => void) => useContext(StoreContext)?.setBenefitTypeEditModal ?? (() => {});

export const useQle = (): QLEType | null => useContext(StoreContext)?.qle ?? null;

// eslint-disable-next-line no-unused-vars
export const useSetQle = (): ((b: QLEType) => void) => useContext(StoreContext)?.setQleData ?? (() => {});

export const useSmoker = (): boolean => useContext(StoreContext)?.smoker ?? false;

// eslint-disable-next-line no-unused-vars
export const useSetSmoker = (): ((b: boolean) => void) => useContext(StoreContext)?.setSmoker ?? (() => {});
